import { render, staticRenderFns } from "./ConversionStatsCard.vue?vue&type=template&id=08188eab&"
import script from "./ConversionStatsCard.vue?vue&type=script&lang=js&"
export * from "./ConversionStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports